export default "__VITE_ASSET__C7b9PXPH__";